import { render, staticRenderFns } from "./ProjectWeddingEventOverview.vue?vue&type=template&id=658fe76f"
import script from "./ProjectWeddingEventOverview.vue?vue&type=script&lang=ts"
export * from "./ProjectWeddingEventOverview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports